import { Image } from './image';

export class Server extends Image
{
    public images: Image[] = [];
}
